const list = {
  inputName: 'First and Last Name',
  inputUsername: 'Username',
  inputLogin: 'Login',
  inputCpf: 'CPF',
  inputCellphone: 'Cellphone',
  inputDdd: 'DDD',
  inputEmail: 'Email',
  inputPhoneNumber: 'Cellphone',
  inputSelect: 'Select',
  inputSearchFarm: 'Search for a farm',
  inputWriteHere: 'Type here',
  inputPassword: 'Password',
  inputNewPassword: 'New Password',
  inputConfirmNewPassword: 'Confirm the New Password',
  inputPasswordHintTitle: 'The password must have:',
  inputConfirmPasswordHintTitle: 'The password does not match',
  inputPasswordHint1: 'At least 6 characters',
  inputPasswordHint2: '1 number',
  inputPasswordHint3: '1 lowercase letter',
  inputPasswordHint4: '1 uppercase letter',
  inputPasswordHint5: '1 special character (*&$!)',
  inputPasswordHint6: 'Only numbers',
  inputConfirmPassword: 'Confirm password',
  inputCode: 'Verification code',
  buttonActionBack: 'Return',
  buttonEnter: 'Enter',
  buttonAccess: 'Access',
  buttonAlter: 'Change',
  buttonAltering: 'Changing',
  buttonEntering: 'Entering..',
  buttonAcessing: 'Accessing..',
  buttonRegister: 'Register',
  buttonRegistering: 'Registering...',
  buttonConfirm: 'Confirm',
  buttonConfirming: 'Confirming...',
  buttonSend: 'Send',
  buttonSending: 'Sending...',
  buttonGoSelectFarm: 'Select Farm',
  buttonBack: 'Back',
  validateRequired: 'Required field',
  validateInvalidEmail: 'Invalid email',
  validateInvalidUsername: 'Invalid username',
  validatePhoneMin: 'The phone number must include DDD + 9 digits',
  validateMinPassword: 'Password must have 6 numeric digits',
  validatePasswordMin: 'Password must have 6 numeric digits',
  validatePasswordMax: 'Password must have 6 numeric digits',
  validatePasswordOnlyNumbers: 'Password must contain only numeric digits',
  validatePasswordOneLowercaseCharacter: 'At least one lowercase character',
  validatePasswordOneUppercaseCharacter: 'At least one uppercase character',
  validatePasswordOneNumber: 'At least one number',
  validatePasswordOneSpecialCharacter: 'At least one special character e.g.: @,$,!,%...',
  validatePasswordNotEquals: 'Passwords do not match',
  validateCodeOnlyNumber: 'The code must contain only numbers',
  validateCodeFormatInvalid: 'Invalid format',
  loginNewPassword: 'You need to change your password!',
  codeMismatchExceptionInvalidVerificationCode: 'Invalid verification code, please try again.',
  forgotPasswordExceptionCodeSendingSuccess: 'We have sent a verification code to your email. If you do not receive the email in a few minutes, check your spam folder or repeat the process.',
  forgotPasswordExceptionContactVerifiedRequired: 'You must have verified email or phone to recover your password.\nPlease contact support at +55 19 97144-1818',
  forgotPasswordExceptionDefaultError: 'Error trying to recover the password, please try again.',
  forgotPasswordExceptionPasswordChangedSuccessfully: 'Your password has been successfully changed!',
  notAuthorizedExceptionIncorrect: 'Incorrect username or password.',
  userExceptionLogin: 'An error occurred while connecting, please try again.',
  userNotFoundExceptionNotFound: 'User not found',
  userNotFoundExceptionNotFoundCustomOnFarm: 'Your user has not yet been migrated to the New OnFarmApp. Click the link below to access the OnFarmApp in operation on your farm:',
  userNotFoundExceptionNotFoundCustomOnFarmStore: 'Your user has not yet been migrated to the New OnFarmApp. Click the link below to access the store in operation for your farm:',
  usernameExistsExceptionEmailAlreadyExists: 'An account with the provided login already exists.',
  userNotConfirmedExceptionUserIsNotConfirmed: 'User not confirmed.',
  userNotFoundExceptionEmailAndPhoneNotFound: 'You must register both email and phone',
  userNotFoundExceptionPhoneNotFound: 'You must register a phone number, please contact support',
  userNotFoundExceptionEmailNotFound: 'You must register an email, please contact support',
  loginColumnLeftTitle: 'Is this your first access? Register here!',
  loginColumnLeftRegister: 'Register',
  loginTitle: 'Log in to your account',
  loginResetPassword: 'Forgot my password',
  userApp: 'APP User',
  passwordUserApp: 'Password',
  registerColumnLeftTitle: 'Already registered? Click here!',
  registerColumnLeftLogin: 'Login',
  registerTitle: 'Sign up',
  registerColumnRightNotify: 'I agree to receive alerts for new content via email',
  confirmSignUpWelcome: 'Welcome',
  confirmSignUpTitle: 'A verification code has been sent to the registered email, please enter the code to continue:',
  confirmSignUpResendConfirmationCode: 'Resend code',
  confirmSignUpCodeResentSuccessfully: 'Code sent successfully',
  confirmSignUpErrorResendingCode: 'Error sending code, please try again.',
  confirmSignUpVerifiedUser: 'User successfully verified.',
  confirmSignUpVerifiedAlreadyUser: 'User already verified.',
  userContactTitle: 'Please provide your email and phone so you can proceed with using the system.',
  userContactDone: 'Email and cellphone registered!',
  confirmContactTitlePhone: 'A verification code has been sent to your phone, please enter it below.',
  confirmContactTitleEmail: 'A verification code has been sent to your email, please enter it below.',
  confirmContactInputPhoneNumber: 'Resend code',
  confirmContactInputEmail: 'Code sent successfully',
  confirmContactErrorResendingCode: 'Error sending code, please try again.',
  confirmContactVerifiedUser: 'Contact successfully verified.',
  newFarmTitle: 'Register a farm now.',
  newUserTitle: 'Register your user.',
  accessFarmWelcome: 'Welcome',
  accessFarmTitle: 'Access granted for:',
  selectFarmConfirmation: 'Select the farm to proceed:',
  almostThere: 'We are almost there:',
  nowSelectFarmCategory: 'Now select the desired category:',
  forgotPasswordTitle: 'Enter the registered user login.',
  passwordRecoveryTitle: 'Enter the code we sent to your email and create a new password',
  newPasswordInputTitle: 'Enter the new password you would like to use',
  typeReceivedNewPasswordTitle: 'Now choose how you would like to receive a new password',
  newPasswordTitle: 'Set a new password',
  typeReceivedPasswordEmail: 'Receive by email',
  typeReceivedPasswordSms: 'Receive by Sms',
  passwordSentSuccess: 'Password sent successfully, check your email/sms',
  noPoints: 'I don’t want to use points',
  signUpTitle: 'Enter your registration details',
  registerError: 'Error registering user, please try again.',
  labelDigiteNomeUsuario: 'Enter username',
  labelDigiteSenha: 'Enter password',
  labelSelecioneFazendaAvancar: 'Select the farm to proceed',
  labelBemVindo: 'Welcome',
  labelCarregando: 'Loading',
}

export default list;